import { render } from "./ContractList.vue?vue&type=template&id=b4135636&scoped=true"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"

import "./ContractList.vue?vue&type=style&index=0&id=b4135636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4135636"]])

export default __exports__